module.exports = __webpack_public_path__ + "static/media/celu2_2x.91bf306c.png";